/**
 * Что доступно роли в интерфейсе.
 *
 * Таблица зеркалит проверки gateway. Показывать кнопку, которую сервер
 * отклонит с 403, — хуже, чем не показывать её вовсе: человек не понимает,
 * сломалась система или ему нельзя.
 *
 * Это удобство, а не защита: настоящая проверка прав всегда на сервере.
 */

export const ROLE_RANK: Record<string, number> = {
  VIEWER: 0,
  OPERATOR: 1,
  ADMIN: 2,
  OWNER: 3,
  DEVELOPER: 4,
};

export const ROLE_LABEL: Record<string, string> = {
  DEVELOPER: 'Разработчик',
  OWNER: 'Владелец',
  ADMIN: 'Администратор',
  OPERATOR: 'Оператор',
  VIEWER: 'Наблюдатель',
};

export interface Capabilities {
  /** Отвечать на отзывы, править и публиковать ответы. */
  readonly reply: boolean;
  /** Запускать синхронизацию вручную. */
  readonly sync: boolean;
  /** Отмечать ручные пункты чек-листа. */
  readonly checklist: boolean;
  /** Менять настройки организации и портрет бренда. */
  readonly manageSettings: boolean;
  /** Подключать и удалять площадки. */
  readonly managePlatforms: boolean;
  /** Принимать заявки и менять роли. */
  readonly manageTeam: boolean;
  /** Видеть экран оплаты и расходов. */
  readonly viewBilling: boolean;
  /** Менять тарифы, дату оплаты и баланс. */
  readonly editBilling: boolean;
}

const NONE: Capabilities = {
  reply: false,
  sync: false,
  checklist: false,
  manageSettings: false,
  managePlatforms: false,
  manageTeam: false,
  viewBilling: false,
  editBilling: false,
};

export function capabilitiesOf(role: string | null): Capabilities {
  if (!role) return NONE;
  const rank = ROLE_RANK[role] ?? -1;
  const operator = rank >= ROLE_RANK['OPERATOR']!;
  const admin = rank >= ROLE_RANK['ADMIN']!;

  return {
    reply: operator,
    sync: operator,
    checklist: operator,
    manageSettings: admin,
    managePlatforms: admin,
    manageTeam: admin,
    viewBilling: admin,
    // Тарифы и себестоимость правит только поставщик системы.
    editBilling: role === 'DEVELOPER',
  };
}

/** Пояснение, почему действие недоступно. Показывается вместо кнопок. */
export const NO_ACCESS_HINT = 'Доступно администратору организации';
